import { LocalStorageE } from "src/e2e-redesign/layout";

export const FormChoiceType = {
    START: 'start',
    CONTINUE: 'continue'
} as const;

export const setFormChoice = (choice: typeof FormChoiceType[keyof typeof FormChoiceType]) => {
    localStorage.setItem(LocalStorageE.formChoice, choice);
};